<template>
    <div class="container d-flex justify-content-center">
        <div class="flex-grow-1" style="max-width: 617px">
            <div class="step-title text-center">{{$trans('storefront::flexible_packaging.request_a_quote')}}</div>
            <div class="spacer-56"></div>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px 12px; margin-bottom: 16px">
                <detail-form-input-group v-model="store.data.first_name" name="first_name" :required="true"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.last_name" name="last_name" :required="true"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.email" name="email" :required="true"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.phone" name="phone" :required="true"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.company" name="company"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.industry" name="industry"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.country" name="country" :required="true"></detail-form-input-group>
                <detail-form-input-group v-model="store.data.city" name="city" :required="true"></detail-form-input-group>
            </div>

            <detail-form-input-group v-model.lazy="store.data.order_quantity" name="order_quantity" :required="true" style="margin-bottom: 16px"></detail-form-input-group>
            <detail-form-input-group v-model="store.data.how_did_you_find_us" name="how_did_you_find_us"></detail-form-input-group>

            <div class="spacer-32"></div>

            <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-2">
                <button type="button" class="btn btn-outline-secondary text-uppercase" style="min-width: 150px" @click="store.previousStep">{{$trans('storefront::flexible_packaging.previous')}}</button>
                <button type="button" class="btn btn-secondary text-uppercase" style="min-width: 150px" @click="store.nextStep">{{$trans('storefront::flexible_packaging.next')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";
import DetailFormInputGroup from "./detail-form/DetailFormInputGroup";
import { ref, watch } from 'vue';
import {clamp} from "lodash";
import {stepValid} from "../../js/validation";

export default {
    components: {DetailFormInputGroup, FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    mounted() {
        let app = this;

        watch(() => app.store.data.order_quantity, ()=> {
            let clampedValue = clamp(app.store.data.order_quantity, 2000, 10000);
            if (parseFloat(app.store.data.order_quantity) !== clampedValue) {
                app.store.data.order_quantity = clampedValue;

                $(`[name='order_quantity']`).addClass("shake-animation");
                setTimeout(function() {
                    $(`[name='order_quantity']`).removeClass("shake-animation");
                }, 100);
            }
        });
    },
}
</script>
